import React from 'react';

const CloseIcon = props => (
  <svg viewBox='0 0 15 15' {...props}>
    <path d='M7.5 6.4L13.9 0 15 1.1 8.6 7.5l6.4 6.4-1.1 1.1-6.4-6.4L1.1 15 0 13.9l6.4-6.4L0 1.1 1.1 0l6.4 6.4z' />
  </svg>
);

export default CloseIcon;
